<template>
  <div class="pointm" >
    <div class="sticky">
      <div class="header">
        <img src="@/assets/mobile/back.png" alt="" @click="back()" />
        <p>分钟数记录</p>
      </div>
    </div>
    <div class="pointbox" @scroll.passive="handleScroll" ref="pointm">
      <p class="title">
        当前分钟数： <span>{{ point }}</span>
      </p>
      <ul>
        <li v-for="(item, index) in tableData" :key="index">
          <p>
            <span>{{ item.cause }}</span>
            <span>{{ item.ai_drop }}</span>
          </p>
          <p>{{ item.remark }}</p>
          <p>
            <span>{{ item.createtime }}</span>
          </p>
		  <p v-if="item.effect_time != '--'">
		    <span>有效期：{{item.effect_time}}到{{item.expire_time}}</span>
		  </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { userGetAiDropList } from "@/api/user";
export default {
  data() {
    return {
      point: "20",
      tableData: [],
      last_page:2,
      page: 1,
    };
  },
  mounted() {
    this.userGetAiDropList();
  },
  methods: {
    handleScroll(){
        if (this.$refs.pointm.clientHeight + this.$refs.pointm.scrollTop === this.$refs.pointm.scrollHeight) {
            if(this.page<this.last_page){
                this.page++
                this.userGetAiDropList()
            }
        }
    },
    userGetAiDropList() {
      userGetAiDropList({ page: this.page }).then((res) => {
        if(this.page==1){
            this.tableData=res.data.data.data
        }else{
            this.tableData = this.tableData.concat(res.data.data.data)
        }
        this.point = res.data.ai_drop;
        this.last_page = res.data.data.last_page;
      });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less">
.pointm {
  background-color: #f4f5f7;
  min-height: 100vh;
  .sticky {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
  }
  .header {
    display: flex;
    align-items: center;
    height: 60px;
    img {
      height: 18px;
      padding: 0 20px;
    }
    p {
      flex: 1 0 10%;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      padding-right: 30px;
    }
  }
  .pointbox {
    height: calc(100vh - 60px);
    overflow-y: scroll;
    padding: 20px;
    .title {
      color: #020713;
      font-weight: 700;
      font-size: 18px;
      margin-bottom: 18px;
      span {
        color: #2d8af5;
      }
    }
    ul {
      li {
        width: 100%;
        padding: 12px 16px;
        background: #ffffff;
        border-radius: 8px;
        margin-bottom: 16px;
        p:nth-child(1) {
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          line-height: 26px;
          font-weight: 700;
        }
        p:nth-child(2) {
          font-size: 13px;
          line-height: 24px;
          color: #999;
        }
        p:nth-child(3) {
          display: flex;
          justify-content: space-between;
          span:nth-child(1) {
            line-height: 22px;
            font-size: 13px;
            color: #999;
          }
          span:nth-child(2) {
            font-size: 14px;
            color: #666;
          }
        }
		p:nth-child(4) {
		  display: flex;
		  justify-content: space-between;
		  span:nth-child(1) {
		    line-height: 22px;
		    font-size: 13px;
		    color: #999;
		  }
		  span:nth-child(2) {
		    font-size: 14px;
		    color: #666;
		  }
		}
      }
    }
  }
}
</style>